@if (activeSectionRoute$ | async) {}
@if (routerEvents$ | async) {}

<div class="st-mobile-left-menu">
  <div class="st-mobile-left-menu-top-section">
    <img
      class="menu-logo"
      src="assets/images/HeaderAdroitLogo.svg"
      alt=""
    />
    <div class="st-mobile-left-menu-top-section-navigators">
      @if (homeButton() && homeButton()!.routeUrl.length) {
        <a
          [title]="homeButton()!.title"
          (click)="goToHome(homeButton()!.routeUrl)"
          [ngClass]="{ active: isStaticButtonActive() === 'home' }"
          class="body-medium-bold"
        >
          <em [class]="homeButton()!.iconClass"></em>
          <span>Home</span>
        </a>
      }
      @for (nav of navigationList(); track $index) {
        <a
          (click)="selectSection(nav)"
          [ngClass]="{ active: (activeSectionRoute$ | async)?.id === nav.id }"
          class="body-medium-bold"
        >
          <em [class]="nav.iconClass"></em>
          <span>{{ nav.name }}</span>
          @if (nav.children.length) {
            <em class="icon-caret-right ml-auto"></em>
          }
        </a>
      }
      @if (tools().length) {
        <a
          (click)="openTools()"
          class="body-medium-bold"
        >
          <em class="icon-circles-four"></em>
          <span>Apps</span>
          <em class="icon-caret-right ml-auto"></em>
        </a>
      }
    </div>
  </div>
  <div class="st-mobile-left-menu-bottom-section custome-menu-mobile">
    <a
      class="profile-btn cursor-pointer background-surface-base-alpha-10-bg"
      (click)="toggleMenu($event, profileMenue)"
      [ngClass]="{ active: isStaticButtonActive() === 'profile' }"
    >
      <img
        [src]="profile().profileImg"
        alt=""
      />
      <span class="body-medium-bold">{{ this.userName() }}</span>

      <p-menu
        #profileMenue
        [model]="dropDownItems"
        [popup]="true"
      >
        <ng-template pTemplate="start">
          <div class="menu-header flex gap-spacing-xs px-spacing-xl">
            <img
              [src]="profile().profileImg"
              alt=""
            />
            <div class="flex flex-column align-items-start gap-spacing-default">
              <span class="label-small-regular text-caption-color"
                >Signed in as</span
              >
              <span class="label-large-bold text-primary-color">
                {{
                  this.userName().length > 24
                    ? this.userName().substring(0, 24) + "..."
                    : this.userName()
                }}
              </span>
            </div>
          </div>
          <div class="px-spacing-xl pt-spacing-xs">
            <hr class="divider-line w-full border-neutral-muted-l2-bg" />
          </div>
        </ng-template>
      </p-menu>
    </a>
  </div>
</div>
